#import "../fragments/SearchPerformerFragment.gql"
query SearchPerformers(
  $term: String!
  $page: Int
  $per_page: Int
  $filter: PerformerSearchFilter
  $studioId: ID
  $hasStudioId: Boolean! = false
) {
  searchPerformers(
    term: $term
    page: $page
    per_page: $per_page
    filter: $filter
  ) {
    count
    performers {
      ...SearchPerformerFragment
      studios(studio_id: $studioId) @include(if: $hasStudioId) {
        scene_count
      }
    }
    facets {
      genders {
        gender
        count
      }
    }
  }
}
